import styled from "styled-components";

export const AlarmChart = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const AlarmChartTitle = styled.div`
  margin-bottom: 16px;
  font-size: 1.6rem;
`;

export const AlarmChartStatus = styled.div`
  display: flex;
  width: 100%;
  padding: 0 4px;
  margin-bottom: 6px;
  justify-content: space-between;

  div {
    display: flex;
    color: ${(props) => props.theme.colors.black70};
    align-items: center;
  }
`;

export const AlarmChartContent = styled.div`
  width: 100%;
  min-width: 580px;
  height: 360px;
  padding: 20px;
  border: 1px solid ${(props) => props.theme.colors.black8};
  border-radius: 6px;
`;
